import { useEffect } from "react";

const ClearURL = () => {
  useEffect(() => {
    const url = new URL(window.location.href);

    const hasStripeParams =
      url.searchParams.has("payment_intent") ||
      url.searchParams.has("payment_intent_client_secret") ||
      url.searchParams.has("setup_intent") ||
      url.searchParams.has("setup_intent_client_secret") ||
      url.searchParams.has("redirect_status");

    if (hasStripeParams) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return null;
};

export default ClearURL;
